import { useMutation, type UseMutationOptions, type UseMutationResult } from "@tanstack/react-query";
import type { ProblemResponse, HTTPResponse } from "@/lib/http/useHTTP";

export const useHTTPMutation = <T, U>(options: UseMutationOptions<HTTPResponse<T>, ProblemResponse, U>): UseMutationResult<HTTPResponse<T>, ProblemResponse, U> => useMutation(options);
